import { useCallback, useEffect, useMemo, useState } from 'react';

export default function useDepartmentResourceFeedback({ items = [], dataIdKey, dataAttribute }) {
	const [pendingDepartmentResourceChange, setPendingDepartmentResourceChange] = useState(null);

	const itemIdSet = useMemo(() => {
		return new Set((Array.isArray(items) ? items : []).reduce((results, item) => {
			if(!item || !dataIdKey || !(dataIdKey in item)) return results;

			results.push(`${item[dataIdKey]}`);
			return results;
		}, []));
	}, [items, dataIdKey]);

	useEffect(() => {
		if(!pendingDepartmentResourceChange || !dataAttribute) return;

		const { changeType, dataId } = pendingDepartmentResourceChange;
		const item_exists = itemIdSet.has(`${dataId}`);

		if(changeType === 'add' && item_exists)
		{
			window.requestAnimationFrame(() => {
				const target_row = document.querySelector(`[${dataAttribute}="${dataId}"]`);
				if(target_row && typeof target_row.scrollIntoView === 'function')
				{
					target_row.scrollIntoView({behavior:'smooth', block:'center'});
				}
			});

			setPendingDepartmentResourceChange(null);
		}
		else if(changeType === 'remove' && !item_exists)
		{
			setPendingDepartmentResourceChange(null);
		}
	}, [dataAttribute, itemIdSet, pendingDepartmentResourceChange]);

	const startDepartmentResourceFeedback = useCallback((changeType, dataId) => {
		setPendingDepartmentResourceChange({changeType, dataId:`${dataId}`});
	}, []);

	const clearDepartmentResourceFeedback = useCallback(() => {
		setPendingDepartmentResourceChange(null);
	}, []);

	const isDepartmentResourcePendingRemoval = useCallback((dataId) => {
		if(!pendingDepartmentResourceChange || pendingDepartmentResourceChange.changeType !== 'remove') return false;

		return pendingDepartmentResourceChange.dataId === `${dataId}`;
	}, [pendingDepartmentResourceChange]);

	return {
		departmentResourceLoading: pendingDepartmentResourceChange !== null,
		departmentResourceAddLoading: pendingDepartmentResourceChange?.changeType === 'add',
		isDepartmentResourcePendingRemoval,
		startDepartmentResourceFeedback,
		clearDepartmentResourceFeedback,
	};
}
